export const SALES_CONTACT = {
  name: 'Grant Herrera',
  title: 'Head of Growth',
  email: 'grantherrera@foodfluence.ai',
  /** E.164 — used for sms: / tel: links */
  phone: '+13464382261',
  phoneDisplay: '+1 (346) 438-2261',
  /** Opens a WhatsApp chat with Grant (same number as phone). */
  whatsappUrl: 'https://wa.me/13464382261',
  instagramHandle: 'herreragrantt',
  instagramUrl: 'https://www.instagram.com/herreragrantt/',
};

export const HIGH_PAYING_THRESHOLD = 300;
export const NEW_BADGE_DAYS = 14;

/** Hard cap on the propose form's "Who do you know there?" note, shown as a live counter. */
export const PROPOSAL_NOTE_LIMIT = 300;
/** The counter turns amber at this length. */
export const PROPOSAL_NOTE_WARN_AT = 270;

export const QUALIFIED_MEETING_COPY =
  'A qualified meeting is a 15+ minute call between Foodfluence and your contact.';

export const NOT_SELECTED_COPY =
  "Hey! Looks like someone else made the intro that converted to a meeting. Apologies! " +
  "If you think there's been a mistake, reach out to support — and keep doing bounties.";

export const CLAIM_DISCLAIMER =
  'Heads up: claiming doesn’t reserve the bounty — the first intro that converts to a qualified meeting gets paid.';
